import { requestHandler } from "../lib/utils/network-client";

export function getCareers(params = {}) {
  return requestHandler("/careers", {
    params
  });
}

export function createCareer(payload) {
  return requestHandler("/careers", {
    method: "POST",
    body: payload
  });
}

export function updateCareer(id, payload) {
  return requestHandler(`/careers/${id}`, {
    method: "PUT",
    body: payload
  });
}

export function deleteCareer(id) {
  return requestHandler(`/careers/${id}`, {
    method: "DELETE"
  });
}
